import { Description } from "./Description"
import { Status } from "./Status"
import { Template } from "./Template"

export const DescriptionTab = Description
export const StatusTab = Status
export const TemplateTab = Template


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/tabs/index.ts